<div class="bs-table no-wrap" [ngClass]="{ 'force-desktop-layout': forceDesktopLayout() }">
  <table class="table table-hover">
    <thead>
      @if (gridHeaderColumns.length === 1) {
        <tr class="thead" data-cy="tableHeader" data-testid="tableHeader">
          @if (checkAble) {
            <th class="checkAble"></th>
          }
          @for (column of gridHeaderColumns[0]; track column) {
            <th
              (click)="onHeaderClick(column)"
              [ngStyle]="column.headStyles ?? {}"
              [ngClass]="column.headClasses ?? {}"
              [class.sortable]="sortAble"
            >
              @if (sortField === column.field) {
                <span>
                  <i class="fas" [class.fa-arrow-up]="sortOrder === 'asc'" [class.fa-arrow-down]="sortOrder === 'desc'"></i>
                </span>
              }
              {{ column.display ?? column.field }}
              @if (column.tooltip) {
                <chitin-icon
                  icon="fa-solid fa-circle-info"
                  class="ms-1"
                  style="color: var(--color-text-subtle)"
                  [ngbTooltip]="column.tooltip"
                />
              }
              @if (column.isBeta) {
                <span class="badge rounded-pill bg-pink badge-new"> beta </span>
              }
            </th>
          }
        </tr>
      }
      @if (gridHeaderColumns.length === 2) {
        @for (gridHeaderRow of gridHeaderColumns; track gridHeaderRow; let i = $index) {
          <tr class="thead" data-cy="tableHeader" data-testid="tableHeader">
            @if (checkAble && i === 0) {
              <th rowspan="2" class="checkAble"></th>
            }
            @for (column of gridHeaderRow; track column) {
              <th
                (click)="onHeaderClick(column)"
                [ngStyle]="column.headStyles ?? {}"
                [ngClass]="column.headClasses ?? {}"
                [class.sortable]="sortAble"
                [colSpan]="column.colspan ?? 1"
                [rowSpan]="column.rowspan ?? 1"
              >
                @if (sortField === column.field) {
                  <span>
                    <i class="fas" [class.fa-arrow-up]="sortOrder === 'asc'" [class.fa-arrow-down]="sortOrder === 'desc'"></i>
                  </span>
                }
                {{ column.display ?? column.field }}
                @if (column.isBeta) {
                  <span class="badge rounded-pill bg-pink badge-new">beta</span>
                }
              </th>
            }
          </tr>
        }
      }
      @if (hasFilters) {
        <tr class="tfilter" data-cy="tableFilter" data-testid="tableFilter">
          @if (checkAble) {
            <th class="checkAble">
              @if (allowCheckAll()) {
                <app-square-checkmark [(value)]="checkAll" (valueChange)="onCheckAll($event)" />
              }
            </th>
          }
          @for (column of gridBodyColumns; track column) {
            <th>
              <app-data-grid-filter
                [value]="filterValues()[column.field] ?? column.filterDefaultValue"
                [column]="column"
                (filterChanged)="onFilterChanged($event.value, $event.column)"
                [isLoading]="isLoading"
              />
            </th>
          }
        </tr>
      }
      <ng-content select="[summaryTop]" />
    </thead>
    <tbody class="border-0" data-cy="products" data-testid="products">
      @if (!data.length && !isLoading) {
        <tr>
          <td [colSpan]="gridBodyColumns.length + (checkAble ? 1 : 0)" class="empty-table">
            <div class="alert alert-warning" role="alert">
              <div class="alert-message" data-cy="emptyTableText" data-testid="emptyTableText">No results found</div>
            </div>
          </td>
        </tr>
      }
      @if (isLoading && (!showLoadingInitOnly || data.length <= 0)) {
        @for (_ of [].constructor(loadingRowsCount); track $index) {
          <tr>
            @for (column of gridBodyColumns; track column) {
              <td class="placeholder-glow">
                @if (!column.skipLoadingPlaceholder) {
                  <span class="placeholder placeholder-lg col-12">L</span>
                }
              </td>
            }
          </tr>
        }
      }
      @if (!isLoading || showLoadingInitOnly) {
        @for (item of data; track item; let i = $index) {
          <tr
            data-cy="tableRow"
            data-testid="tableRow"
            [ngClass]="{
              'table-dark': isItemActive(item),
              'row-rise': animateRows,
              realtimeLoadedRow: showLoadingInitOnly && data.length <= 0,
            }"
            [style.--cl-row-i]="i"
          >
            @if (checkAble) {
              <td class="checkAble">
                <app-square-checkmark [(value)]="checkedRows[i].checked" (valueChange)="onCheckItem($event, i)" />
              </td>
            }
            @for (column of gridBodyColumns; track column) {
              <td
                (click)="onItemClick(item, column)"
                data-cy="tableRowItem"
                data-testid="tableRowItem"
                [ngClass]="column.rowClasses ?? {}"
                [ngStyle]="column.rowStyles ?? {}"
              >
                <span class="cell-label">{{ column.display ?? column.field }}</span>
                @if (column.templateRef) {
                  <span
                    class="cell-value"
                    [ngTemplateOutlet]="templates[column.templateRef]"
                    [ngTemplateOutletContext]="{ item, index: i, column }"
                  ></span>
                }
                @if (!column.templateRef) {
                  <span
                    class="cell-value"
                    data-cy="tableRowItemValue"
                    data-testid="tableRowItemValue"
                    placement="top"
                    ngbTooltip="{{ item | gridField: column }}"
                    container="body"
                  >
                    {{ item | gridField: column }}
                  </span>
                }
              </td>
            }
          </tr>
        }
      }
      <ng-content select="[summaryBottom]" />
    </tbody>
  </table>
</div>
